import { IPin, PinType } from 'src/@interfaces'

export const getPinSize = (pinSize: number, metaSize?: string) =>
  metaSize ? `${metaSize}%` : `${pinSize}px`

export const getPinSizeAsNumber = (pin: IPin, pinsSize: any): number | undefined => {
  const validPinSizeTypes = ['number', 'string']

  const catalogPinsSizeAsNumber = Number(pinsSize)

  const invalidPin =
    !validPinSizeTypes.includes(typeof pinsSize) || Number.isNaN(catalogPinsSizeAsNumber)

  if (invalidPin) {
    return undefined
  }

  if (pin.pinType === PinType.PIN && pin.metadata?.size) {
    return pin.metadata.size
  }

  return catalogPinsSizeAsNumber
}
